import { j as m } from "./jsx-runtime-3tyXYecC.mjs";
import { m as p } from "./tss-DN0acMKN.mjs";
import { e as f } from "./enhance-anchor-props-DgCJ7ag3.mjs";
import { B as l } from "./Box-B5hjovXR.mjs";
import { f as u } from "./format-base-props-8NDUNDcL.mjs";
const x = p()(() => ({
  root: {
    color: "unset",
    cursor: "unset",
    fontWeight: "unset",
    position: "unset",
    textDecoration: "unset",
    "&:any-link": {
      cursor: "pointer"
      // simulate browser default
    },
    "&:hover": {
      color: "unset",
      textDecoration: "none"
      // override browser default for easier styling
    },
    "&:focus-visible:after": {
      display: "none"
    }
  }
})), P = (t) => {
  const { className: s, component: e = "a", containerRef: n, ...o } = t, { classes: r, cx: a } = x(), c = u(o), i = f(c);
  return (
    // `children` is included in `rest`
    // eslint-disable-next-line jsx-a11y/anchor-has-content
    /* @__PURE__ */ m.jsx(
      l,
      {
        ...i,
        className: a(r.root, s, "fab-LinkUnstyled"),
        component: e,
        "data-fabric-component": o["data-fabric-component"],
        ref: n
      }
    )
  );
};
export {
  P as L
};
//# sourceMappingURL=link-unstyled-CvXR-8s6.mjs.map
